import * as React from 'react';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { List } from '@fluentui/react/lib/List';
import { fileToTypeScreen, throwError, notesScreen, activeTaskScreen, newTaskScreen, toggleLoading, successScreen } from '../actions/navigationWorker';
import { LogError } from '../actions/errorWorker';
import { getEntityTypeText } from '../actions/helper';
import { fileEmail, fileExistingItem } from '../actions/FilerWorker';
import { getQueuedEmails } from '../actions/queueWorker';

export interface AppProps {
    hide: boolean;
}

export interface AppState {
    selected_clients: any,
    file_to_type: any,
    doc_category: any,
    doc_type: any,
    doc_subtype: any,
    doc_permission: any,
    doc_access: any,
    active_tasks: any,
    filed_notes: any,
    subject: any,
    task_type: any,
    task_subtype: any,
    task_status: any,
    task_assignee: any,
    loginUserName: string,
    note_date: string | null
}

class Summary extends React.Component<AppProps, AppState> {
    constructor(props) {
        super(props);
        const not_selected = { id: 'not_selected', name: '<NOT SELECTED>' };
        const selected_clients = JSON.parse(sessionStorage.getItem('selected_clients')) || [];
        const file_to_type = JSON.parse(sessionStorage.getItem('file_to_type')) || { id: 'note', name: 'Note' };
        const doc_category = JSON.parse(sessionStorage.getItem('doc_category')) || [not_selected];
        const doc_type = JSON.parse(sessionStorage.getItem('doc_type')) || {};
        const doc_subtype = JSON.parse(sessionStorage.getItem('doc_subtype'));
        const doc_permission = JSON.parse(sessionStorage.getItem('doc_permission')) || {};
        const doc_access = JSON.parse(sessionStorage.getItem('doc_access')) || [not_selected];
        const active_tasks = JSON.parse(sessionStorage.getItem('selected_active_tasks')) || [];
        const filed_notes = JSON.parse(sessionStorage.getItem('selected_filed_notes')) || [];
        const subject = sessionStorage.getItem('subject');
        const task_type = JSON.parse(sessionStorage.getItem('task_type')) || {};
        const task_subtype = JSON.parse(sessionStorage.getItem('task_subtype')) || not_selected;
        const task_status = JSON.parse(sessionStorage.getItem('task_status')) || {};
        const task_assignee = JSON.parse(sessionStorage.getItem('task_assignee'));
        const loginUserName = localStorage.getItem('loginUserName') || '';
        const note_date = sessionStorage.getItem('note_date');
        
        this.state = {
            selected_clients: selected_clients,
            file_to_type: file_to_type,
            doc_category: doc_category.length === 0 ? [not_selected] : doc_category,
            doc_type: doc_type,
            doc_subtype: doc_subtype ? doc_subtype : not_selected,
            doc_permission: doc_permission,
            doc_access: doc_access.length === 0 ? [not_selected] : doc_access,
            active_tasks: active_tasks,
            filed_notes: filed_notes,
            subject: subject,
            task_type: task_type,
            task_subtype: task_subtype,
            task_status: task_status,
            task_assignee: task_assignee,
            loginUserName: loginUserName,
            note_date: note_date
        };
    }

    componentDidMount() {
        if (localStorage.getItem('skip_summary') === 'true') {
            this.fileEmailClick();
        }
    }

    back_to_file_type = () => {
        if (this.state.file_to_type.id === 'note') {
            notesScreen(true);
        } else if (this.state.file_to_type.id === 'activetask') {
            activeTaskScreen(true);
        } else if (this.state.file_to_type.id === 'newtask') {
            newTaskScreen(true);
        } else if (this.state.file_to_type.id === 'existingnote') {
            fileToTypeScreen(true);
        } else {
            fileToTypeScreen(true);
        }
    }

    handleFileClick = () => {
        console.log("=== FILE BUTTON PHYSICALLY CLICKED ===");
        this.fileEmailClick();
    }

    fileEmailClick = async () => {
        console.log("=== FILE BUTTON CLICKED - fileEmailClick called ===");
        console.log("Current state:", {
            file_to_type: this.state.file_to_type,
            selected_clients: this.state.selected_clients,
            doc_type: this.state.doc_type
        });
        
        let otherData = {};
        
        try {
            // Check if there are queued emails - if so, file them instead of current email
            const queuedEmails = getQueuedEmails();
            if (queuedEmails.length > 0) {
                console.log(`Found ${queuedEmails.length} queued emails - using batch filing mode`);
                // Set batch filing mode flag
                sessionStorage.setItem("filing_mode", "queue");
            }
            
            // Show loading overlay AFTER setting the mode
            toggleLoading(true, 'Filing...');
            
            let selected_eIds = [];
            let selected_cats = [];
            let client_access = false;
            let referrer_access = false;
            let profadviser_access = false;

            for (let i = 0; i < this.state.selected_clients.length; i++) {
                selected_eIds.push((this.state.selected_clients[i] as any).id);
            }

            let state_selected_cats = JSON.parse(sessionStorage.getItem('doc_category')) || [];
            for (let i = 0; i < state_selected_cats.length; i++) {
                selected_cats.push((this.state.doc_category[i] as any).id);
            }
            let state_access = JSON.parse(sessionStorage.getItem('doc_access')) || [];
            for (let i = 0; i < state_access.length; i++) {
                let access_id = (state_access[i] as any).id;
                if (access_id === 'is_client_access_accessible') {
                    client_access = true;
                } else if (access_id === 'is_referrer_accessible') {
                    referrer_access = true;
                } else if (access_id === 'is_profadviser_accessible') {
                    profadviser_access = true;
                }
            }

            let file_to_type = this.state.file_to_type;

            if (!file_to_type || !file_to_type.id) {
                throw new Error('File to type not selected. Please select a filing option.');
            }

            if (file_to_type.id === 'note') {
                if (!this.state.doc_type || !this.state.doc_type.id) {
                    throw new Error('Note Type is required. Please select a Note Type.');
                }
                if (!this.state.doc_permission || !this.state.doc_permission.name) {
                    throw new Error('Permission is required. Please select a Permission.');
                }
                
                otherData = {
                    subject: this.state.subject,
                    doctype: this.state.doc_type.id,
                    entity_ids: selected_eIds,
                    permission: this.state.doc_permission.name,
                    categories: selected_cats,
                    is_client_access_accessible: client_access,
                    is_referrer_accessible: referrer_access,
                    is_profadviser_accessible: profadviser_access,
                    username: this.state.loginUserName,
                    fileToType: file_to_type.id,
                    role: sessionStorage.getItem('selected_entity_type'),
                    note_date: this.state.note_date
                };
                if (sessionStorage.getItem('doc_subtype')) {
                    const subtype = JSON.parse(sessionStorage.getItem('doc_subtype'))
                    if (subtype.id && subtype.id !== 'null') {
                        otherData['docsubtype'] = subtype.id;
                    }
                }
            } else if (file_to_type.id === 'newtask') {
                
                if (!this.state.task_type || !this.state.task_type.id) {
                    throw new Error('Task Type is required. Please select a Task Type.');
                }
                if (!this.state.task_subtype || !this.state.task_subtype.id) {
                    throw new Error('Task Sub Type is required. Please select a Task Sub Type.');
                }
                if (!this.state.task_status || !this.state.task_status.id) {
                    throw new Error('Task Status is required. Please select a Task Status.');
                }
                
                otherData = {
                    subject: this.state.subject,
                    tasktype: this.state.task_type.id,
                    tasksubtype: this.state.task_subtype.id,
                    entity_ids: selected_eIds,
                    taskstatus: this.state.task_status.id,
                    username: this.state.loginUserName,
                    fileToType: file_to_type.id,
                    role: sessionStorage.getItem('selected_entity_type')
                };
                
                // Add assignee if selected (otherwise backend will assign to current user)
                if (this.state.task_assignee && this.state.task_assignee.id) {
                    otherData['assignee'] = this.state.task_assignee.id;
                }
            } else if (file_to_type.id === 'activetask') {
                otherData = {
                    entity_ids: selected_eIds,
                    username: this.state.loginUserName,
                    fileToType: file_to_type.id,
                    role: sessionStorage.getItem('selected_entity_type')
                };
            } else if (file_to_type.id === 'existingnote') {
                // File to existing note(s)
                if (!this.state.filed_notes || this.state.filed_notes.length === 0) {
                    throw new Error('Please select at least one existing note to file to.');
                }
                
                // File to the first selected note
                // Note: Currently only supports filing to one note at a time
                const selectedNote = this.state.filed_notes[0];
                otherData = {
                    entity_ids: selected_eIds,
                    username: this.state.loginUserName,
                    fileToType: 'note',
                    role: sessionStorage.getItem('selected_entity_type')
                };
                
                await fileExistingItem(selectedNote.id, otherData);
                
                // Skip the normal fileEmail call for existing notes
                const successNode = document.getElementById('SuccessMessage');
                const hasSuccessContent = successNode ? successNode.hasChildNodes() : false;

                if (!hasSuccessContent) {
                    const redirectUrl = sessionStorage.getItem('redirectUrl');
                    successScreen(false, redirectUrl, 'Go to Notes', 'The email has been successfully filed to Xplan.');
                }
                return; // Exit early since we already handled filing
            }

            await fileEmail(otherData);

            const successNode = document.getElementById('SuccessMessage');
            const hasSuccessContent = successNode ? successNode.hasChildNodes() : false;

            if (!hasSuccessContent) {
                const redirectUrl = sessionStorage.getItem('redirectUrl');
                const fileTypeId = this.state.file_to_type?.id || 'note';
                const linkTitle = fileTypeId === 'note' ? 'Go to Notes' : 'Go to Tasks';
                successScreen(false, redirectUrl, linkTitle, 'The email has been successfully filed to Xplan.');
            }
        } catch (err) {
            console.error("Error in fileEmailClick:", err);
            // FIRST: Hide loading overlay BEFORE showing error
            toggleLoading(false);
            // SECOND: Clear filing mode on error
            sessionStorage.removeItem('filing_mode');
            // THIRD: Show error (Note: throwError also calls toggleLoading(false) internally)
            throwError(err.message);
            LogError(err, { otherData }, 'fileEmailClick', 'ERROR');
        }
    }



    public render() {
        console.log("=== Summary.render() called ===", {
            hide: this.props.hide,
            skip_summary: localStorage.getItem('skip_summary'),
            file_to_type: this.state.file_to_type
        });
        
        if (this.props.hide) {
            console.log("Summary hidden, returning null");
            return (null);
        }

        console.log("Rendering summary content...");
        const containerStyle: React.CSSProperties = {
            position: 'fixed',
            top: '45px',
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        };

        const contentStyle: React.CSSProperties = {
            flex: 1,
            overflowY: 'auto',
            padding: '8px',
            fontSize: '13px'
        };

        const boxStyle: React.CSSProperties = {
            border: '2px solid #5D3FD6',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '8px'
        };

        const buttonFooterStyle: React.CSSProperties = {
            display: 'flex',
            gap: '8px',
            padding: '12px 8px',
            borderTop: '1px solid #ccc',
            flexShrink: 0
        };

        if (this.state.file_to_type.id === 'note') {
            return (
                <div style={containerStyle}>
                    <div style={contentStyle}>
                        <div style={boxStyle}>
                            <p style={{ marginTop: 0 }}>If the details below are correct, please file email to Xplan:</p>
                            <div className='ms-Grid'>
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Selected {getEntityTypeText(sessionStorage.getItem('selected_entity_type'))}(s):</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        <List items={this.state.selected_clients} />
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>File To:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.file_to_type.name}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Subject:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.subject}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Type:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.doc_type.name}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Subtype:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.doc_subtype.name}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Permission:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.doc_permission.name}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Access:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        <List items={this.state.doc_access} />
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Category:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        <List items={this.state.doc_category} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={buttonFooterStyle}>
                        <DefaultButton 
                            data-automation-id='btnBack' 
                            text='Back' 
                            onClick={this.back_to_file_type}
                            style={{ flex: 1 }}
                        />
                        <PrimaryButton 
                            data-automation-id='btnNext' 
                            text='File' 
                            onClick={this.handleFileClick}
                            style={{ flex: 1 }}
                        />
                    </div>
                </div>
            );
        } else if (this.state.file_to_type.id === 'existingnote') {
            return (
                <div style={containerStyle}>
                    <div style={contentStyle}>
                        <div style={boxStyle}>
                            <p style={{ marginTop: 0 }}>If the details below are correct, please file email to Xplan:</p>
                            <div className='ms-Grid'>
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Selected {getEntityTypeText(sessionStorage.getItem('selected_entity_type'))}(s):</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        <List items={this.state.selected_clients} />
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>File To:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        Existing Notes
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Existing Note(s):</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        <List items={this.state.filed_notes} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={buttonFooterStyle}>
                        <DefaultButton 
                            data-automation-id='btnBack' 
                            text='Back' 
                            onClick={this.back_to_file_type}
                            style={{ flex: 1 }}
                        />
                        <PrimaryButton 
                            data-automation-id='btnNext' 
                            text='File' 
                            onClick={this.handleFileClick}
                            style={{ flex: 1 }}
                        />
                    </div>
                </div>
            );
        } else if (this.state.file_to_type.id === 'activetask') {
            return (
                <div style={containerStyle}>
                    <div style={contentStyle}>
                        <div style={boxStyle}>
                            <p style={{ marginTop: 0 }}>If the details below are correct, please file email to Xplan:</p>
                            <div className='ms-Grid'>
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Selected {getEntityTypeText(sessionStorage.getItem('selected_entity_type'))}(s):</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        <List items={this.state.selected_clients} />
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>File To:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.file_to_type.name}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Active Tasks:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        <List items={this.state.active_tasks} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={buttonFooterStyle}>
                        <DefaultButton 
                            data-automation-id='btnBack' 
                            text='Back' 
                            onClick={this.back_to_file_type}
                            style={{ flex: 1 }}
                        />
                        <PrimaryButton 
                            data-automation-id='btnNext' 
                            text='File' 
                            onClick={this.handleFileClick}
                            style={{ flex: 1 }}
                        />
                    </div>
                </div>
            );
        } else if (this.state.file_to_type.id === 'newtask') {
            return (
                <div style={containerStyle}>
                    <div style={contentStyle}>
                        <div style={boxStyle}>
                            <p style={{ marginTop: 0 }}>If the details below are correct, please file email to Xplan:</p>
                            <div className='ms-Grid'>
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Selected {getEntityTypeText(sessionStorage.getItem('selected_entity_type'))}(s):</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        <List items={this.state.selected_clients} />
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>File To:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.file_to_type.name}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Subject:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.subject}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Type:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.task_type.name}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Subtype:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.task_subtype.name}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Status:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.task_status.name}
                                    </div>
                                </div>
                                <br />
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                                        <strong>Assignee:</strong>
                                    </div>
                                    <div className='ms-Grid-col ms-sm8 ms-md8 ms-lg8'>
                                        {this.state.task_assignee ? this.state.task_assignee.name : 'Assigned to yourself'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={buttonFooterStyle}>
                        <DefaultButton 
                            data-automation-id='btnBack' 
                            text='Back' 
                            onClick={this.back_to_file_type}
                            style={{ flex: 1 }}
                        />
                        <PrimaryButton 
                            data-automation-id='btnNext' 
                            text='File' 
                            onClick={this.handleFileClick}
                            style={{ flex: 1 }}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div style={containerStyle}>
                    <div style={contentStyle}>
                        <div style={boxStyle}>
                            <p style={{ marginTop: 0 }}>No summary available.</p>
                        </div>
                    </div>
                    <div style={buttonFooterStyle}>
                        <DefaultButton 
                            data-automation-id='btnBack' 
                            text='Back' 
                            onClick={this.back_to_file_type}
                            style={{ flex: 1 }}
                        />
                        <PrimaryButton 
                            data-automation-id='btnNext' 
                            text='File' 
                            onClick={this.handleFileClick}
                            style={{ flex: 1 }}
                        />
                    </div>
                </div>
            );
        }
    }
}

export default Summary;
